import { useHistory } from 'react-router-dom';

import queryString from 'query-string';
import CountUp from 'react-countup';
import { Card, CardBody } from 'reactstrap';
import { AiOutlinePercentage } from 'react-icons/ai';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

import vendorAssign from '../../../../../../assets/custom/v2/vendor.svg';

const StatusCard = ({ statusBooking, cardData, filter, nextNavigation }) => {
  const history = useHistory();

  const totalCount =
    cardData?.[statusBooking?.name]?.data?.totalCount || cardData?.[statusBooking?.name]?.data?.totalCount === 0
      ? Number(cardData?.[statusBooking?.name]?.data?.totalCount)
      : null;

  const routeHandler = () => {
    const params = {
      name: statusBooking?.name,
      type: statusBooking?.type,
      ...(!filter?.timelineFilter && { startDate: filter?.startDate, endDate: filter?.endDate }),
      nextNavigation: nextNavigation,
    };
    if (statusBooking?.nextNavigation) {
      history.push({
        pathname: '/v2/booking',
        search: `?${queryString.stringify(params)}`,
      });
    }
  };

  return (
    <Card
      style={{
        border: '1px solid #FFFFFF',
        borderRadius: '20px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)', // Added boxShadow
        cursor: statusBooking?.nextNavigation && 'pointer',
      }}
      className="status-card"
      onClick={routeHandler}
    >
      <CardBody>
        <div className="d-flex justify-content-between">
          <div>
            {/* <FaFire className="icon-fire" size={20} color="#EA9C2B" /> */}
            <img src={statusBooking?.icon ? statusBooking?.icon : vendorAssign} className="img-fluid" alt="" style={{ width: '50px' }} />
          </div>
          <div>
            <p className="m-0 card-status-name" style={{}}>
              {statusBooking?.displayName}
            </p>
            <div style={{ textAlign: 'end' }}>
              {totalCount != null ? (
                <CountUp
                  separator=""
                  className="fw-semibold"
                  start={0}
                  end={totalCount}
                  duration={2}
                  style={{ fontSize: '25px', fontWeight: '500' }}
                />
              ) : (
                <p className="fw-bold text-format-3 m-0">-</p>
              )}
            </div>
          </div>
        </div>
        {cardData?.[statusBooking?.name]?.data?.changePercentage !== null &&
          cardData?.[statusBooking?.name]?.data?.changePercentage !== undefined && (
            <div className="d-flex justify-content-end align-items-center gap-3 mt-3">
              <div className="d-flex gap-2">
                {cardData?.[statusBooking?.name]?.data?.changePercentage > 0 ? (
                  <>
                    {' '}
                    <span>
                      <FaArrowUp color={cardData?.[statusBooking?.name]?.data?.changePercentageColor || '#0AB39C'} />
                    </span>
                    <span style={{ marginTop: '1px' }}>
                      {' '}
                      <span style={{ color: cardData?.[statusBooking?.name]?.data?.changePercentageColor || '#0AB39C' }}>
                        {Math.abs(Number(cardData?.[statusBooking?.name]?.data?.changePercentage)).toFixed(2)}
                      </span>
                      <span>
                        <AiOutlinePercentage color={cardData?.[statusBooking?.name]?.data?.changePercentageColor || '#0AB39C'} />
                      </span>
                    </span>
                  </>
                ) : cardData?.[statusBooking?.name]?.data?.changePercentage < 0 ? (
                  <>
                    <span>
                      <FaArrowDown color={cardData?.[statusBooking?.name]?.data?.changePercentageColor || 'red'} />
                    </span>
                    <span style={{ marginTop: '1px' }}>
                      {' '}
                      <span style={{ color: cardData?.[statusBooking?.name]?.data?.changePercentageColor || 'red' }}>
                        {Math.abs(Number(cardData?.[statusBooking?.name]?.data?.changePercentage)).toFixed(2)}
                      </span>
                      <span>
                        <AiOutlinePercentage color={cardData?.[statusBooking?.name]?.data?.changePercentageColor || 'red'} />
                      </span>
                    </span>
                  </>
                ) : (
                  <p className="fs-12 m-0" style={{ color: '#0AB39C' }}>
                    No Change in Booking
                  </p>
                )}
              </div>
              {cardData?.[statusBooking?.name]?.data?.changePercentage !== 0 && (
                <p className="fs-12 m-0" style={{ color: '#8898AA' }}>
                  Since Yesterday
                </p>
              )}
            </div>
          )}
      </CardBody>
    </Card>
  );
};

export default StatusCard;
